var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('el-row', [_c('div', {
    staticStyle: {
      "height": "750px",
      "background-color": "#FFFFFF"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-row', {
    staticStyle: {
      "padding-left": "46px",
      "padding-top": "40px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('span', [_vm._v("时间")]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "month",
      "placeholder": "请选择",
      "value-format": "yyyy-MM"
    },
    model: {
      value: (_vm.condition.years_date),
      callback: function($$v) {
        _vm.$set(_vm.condition, "years_date", $$v)
      },
      expression: "condition.years_date"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "85px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    on: {
      "click": _vm.Find
    }
  }, [_vm._v("\n                                        查询")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('download-excel', {
    staticClass: "export-excel-wrapper",
    staticStyle: {
      "top": "100px",
      "width": "5%"
    },
    attrs: {
      "fields": _vm.download_excel,
      "name": _vm.condition.project_name,
      "fetch": _vm.ExportForm
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "85px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    }
  }, [_vm._v("导出")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.fullscreenLoading),
      expression: "fullscreenLoading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    staticStyle: {
      "width": "110px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    on: {
      "click": _vm.heavyloadkq
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t        更新考勤表")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.fullscreenLoading),
      expression: "fullscreenLoading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    staticStyle: {
      "width": "110px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B",
      "margin-left": "25px"
    },
    on: {
      "click": _vm.heavyload
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t        更新工资表")])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin": "0px 2%",
      "margin-top": "20px",
      "font-weight": "bold"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('span', [_vm._v("实际出勤人数：" + _vm._s(_vm.total))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('span', [_vm._v("项目名称：" + _vm._s(_vm.condition.project_name))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.condition.actual_estimate),
      callback: function($$v) {
        _vm.$set(_vm.condition, "actual_estimate", $$v)
      },
      expression: "condition.actual_estimate"
    }
  }, [_vm._v("预估")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.condition.actual_estimate),
      callback: function($$v) {
        _vm.$set(_vm.condition, "actual_estimate", $$v)
      },
      expression: "condition.actual_estimate"
    }
  }, [_vm._v("实开")])], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [(this.kqje == null) ? _c('div', [_c('span', [_vm._v("开票金额：")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "50%",
      "margin-left": "2px"
    },
    attrs: {
      "size": "mini",
      "placeholder": " ",
      "clearable": ""
    },
    model: {
      value: (_vm.condition.invoiced_amount),
      callback: function($$v) {
        _vm.$set(_vm.condition, "invoiced_amount", $$v)
      },
      expression: "condition.invoiced_amount"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [(this.kqje !== null) ? _c('div', [_c('span', [_vm._v("开票金额：" + _vm._s(_vm.kqje))])]) : _vm._e()]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [(this.kqje == null) ? _c('button', {
    staticStyle: {
      "width": "75px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B",
      "height": "28px",
      "text-align": "center:padding:auto",
      "border-radius": "5px"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n                                        确定")]) : _vm._e()])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin": "0px 2%"
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('el-table', {
    ref: "table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "header-cell-style": {
        background: '#d3eae2',
        color: '#000000'
      },
      "border": true,
      "row-class-name": _vm.tableRowClassName,
      "data": _vm.tableData,
      "show-summary": "",
      "summary-method": _vm.getSummaries,
      "height": "600",
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "序号",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope_1) {
        return [_vm._v(_vm._s(scope_1.$index + 1))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "post_name",
      "align": "center",
      "label": "岗位",
      "width": "70"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "staff_name",
      "align": "center",
      "label": "姓名",
      "width": "70"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total_wages",
      "align": "center",
      "label": "工资总额",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "base_pay",
      "align": "center",
      "label": "基本工资",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "post_salary",
      "align": "center",
      "label": "岗位工资",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "daily_wage",
      "align": "center",
      "label": "日工资",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "days_attendance",
      "align": "center",
      "label": "应出勤天数",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "事假/缺勤"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "absence_days",
      "align": "center",
      "label": "天数",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deduction_absence",
      "align": "center",
      "label": "扣款",
      "width": "60"
    }
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "actual_attendance_days",
      "align": "center",
      "label": "实出勤天数",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "wages",
      "align": "center",
      "label": "工资额",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "增补项"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "full_work_attendance",
      "align": "center",
      "label": "满勤",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "meal_supplement",
      "align": "center",
      "label": "餐补",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "overtime",
      "align": "center",
      "label": "加班时间",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "overtime_amount",
      "align": "center",
      "label": "加班金额",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "substitute",
      "align": "center",
      "label": "替班",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "telephone_charges",
      "align": "center",
      "label": "话费",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "substitute_salary",
      "align": "center",
      "label": "代岗工资",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "make_up_for_the_early_stage",
      "align": "center",
      "label": "弥补前期",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reward",
      "align": "center",
      "label": "奖励",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "return_of_work_clothes_deposit",
      "align": "center",
      "label": "归还工服押金",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "other_plus",
      "align": "center",
      "label": "其他+",
      "width": "60"
    }
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "扣款项"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "late_deduction",
      "align": "center",
      "label": "迟到扣款",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "penalty_deduction",
      "align": "center",
      "label": "处罚扣款",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "pay_the_work_clothes_deposit",
      "align": "center",
      "label": "发放工服押金",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "other_reduce",
      "align": "center",
      "label": "其他-",
      "width": "60"
    }
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "wages_payable",
      "align": "center",
      "label": "应发工资",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "代扣代缴"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "social_security_deduction",
      "align": "center",
      "label": "社保扣款",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "accident_insurance",
      "align": "center",
      "label": "意外保险",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "accumulation_fund",
      "align": "center",
      "label": "公积金",
      "width": "60"
    }
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "before_tax_paid_salary",
      "align": "center",
      "label": "实发工资(税前)",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "individual_income_tax",
      "align": "center",
      "label": "个人所得税",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "after_tax_paid_salary",
      "align": "center",
      "label": "实发工资(税后)",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "receiving_method_name",
      "align": "center",
      "label": "领取方式",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.show),
            expression: "scope.row.show"
          }],
          staticStyle: {
            "margin-right": "10px"
          },
          attrs: {
            "clearable": "",
            "size": "mini"
          },
          model: {
            value: (scope.row.receiving_method_name),
            callback: function($$v) {
              _vm.$set(scope.row, "receiving_method_name", $$v)
            },
            expression: "scope.row.receiving_method_name"
          }
        }, _vm._l((_vm.lqList), function(item) {
          return _c('el-option', {
            key: item.lable,
            attrs: {
              "label": item.label
            }
          })
        }), 1), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!scope.row.show),
            expression: "!scope.row.show"
          }]
        }, [_vm._v(_vm._s(scope.row.receiving_method_name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "bank_card_number",
      "align": "center",
      "label": "银行卡号",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cardholder_name",
      "align": "center",
      "label": "持卡人",
      "width": "70"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "entry_name",
      "align": "center",
      "label": "项目名称",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id_card",
      "align": "center",
      "label": "身份证号",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "telephone_number",
      "align": "center",
      "label": "电话号",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "gender",
      "align": "center",
      "label": "性别",
      "width": "60"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)])], 1), _vm._v(" "), (_vm.dialogVisible) ? _c('div', [_c('edit', {
    ref: "edit"
  })], 1) : _vm._e()])
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2752d3fc","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gzhsgl/GzMx/tabs/XmGzmx.vue
// module id = null
// module chunks = 